module.exports = __webpack_public_path__ + "static/logo-62ecd268ae2a39f05f8cf0814a74d9b8.png";